export default "__VITE_ASSET__Z9C5Im5t__"